import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAlignmentCenter: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"alignment-center"} maskId="square-filled-radius-0-stroke-1-IconAlignmentCenter"><path fillRule="evenodd" clipRule="evenodd" d="M3 4H21V5H3V4ZM3 4H21V5H3V4ZM3 4H21V5H3V4Z" fill="currentColor"/><path d="M17 11.5V12.5H7V11.5H17Z" fill="currentColor"/><path d="M21 19V20H3V19H21Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconAlignmentCenter;
